import { Button, Modal } from "react-bootstrap";

const DeleteConfirmationModal = ({ loading, onClose, onConfirm, description="Are you sure you want to delete? This action cannot be undone."  }) => {
    return (
        <Modal show onHide={onClose} centered size="lg" style={{ zIndex: 10000 }}>
            <Modal.Header >
                <Modal.Title>Confirmation
                </Modal.Title>
            </Modal.Header>
            <Modal.Body >
            {description}
            </Modal.Body>
            <Modal.Footer style={{ overflowY: "auto", maxHeight: "500px" }}>
                <Button variant="secondary" onClick={onClose} disabled={loading}>Close</Button>
                <Button variant="primary" onClick={onConfirm} disabled={loading}>{loading ? 'Processing...' : 'Confirm'}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default DeleteConfirmationModal;